import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BranchService from "../../services/BranchesService";
import { toast } from "react-toastify";

export const fetchBranches = createAsyncThunk(
  "branch/fetchBranches",
  async (data, { rejectWithValue }) => {
    try {
      const res = await BranchService.getBranches(data);
      return res;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createBranch = createAsyncThunk(
  "branch/createBranch",
  async (data, thunkAPI) => {
    try {
      const res = await BranchService.addBranch(data);
      if (res.status == 1) {
        toast.success(res.message);
        return res;
      } else {
        toast.warning(res.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchBranchById = createAsyncThunk(
  "branch/fetchBranchById",
  async (id) => {
    try {
      const res = await BranchService.getBranchById(id);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateBranch = createAsyncThunk(
  "branch/updateBranch",
  async (data) => {
    try {
      const res = await BranchService.editBranch(data);
      if (res.status == 1) {
        toast.success(res.message);
        return res.data.data;
      } else {
        toast.warning(res.message);
      }
    } catch (error) {
      console.log(error);
    }
  }
);

export const removeBranch = createAsyncThunk(
  "branch/removeBranch",
  async (data) => {
    try {
      const res = await BranchService.deleteBranch(data);
      return data.branch_id;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  branches: [],
  branch: null,
  total_pages: 0,
  total_records: 0,
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //Get All Branches
    builder
      .addCase(fetchBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranches.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.branches = payload?.data || [];
        state.total_pages = payload?.total_pages;
        state.total_records = payload?.total_records;
      })
      .addCase(fetchBranches.rejected, (state) => {
        state.loading = false;
        state.branches = [];
        state.total_pages = 0;
        state.total_records = 0;
      });

    // ADD Branch

    builder
      .addCase(createBranch.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBranch.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.branch = payload;
      })
      .addCase(createBranch.rejected, (state) => {
        state.loading = false;
      });

    // GET BY ID Branch

    builder
      .addCase(fetchBranchById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchById.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.branch = payload;
      })
      .addCase(fetchBranchById.rejected, (state) => {
        state.loading = false;
      });

    //EDIT BRANCH

    builder
      .addCase(updateBranch.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBranch.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.branch = { ...state.branch, ...payload };
      })
      .addCase(updateBranch.rejected, (state) => {
        state.loading = false;
      });

    // DELETE BRANCH

    builder
      .addCase(removeBranch.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeBranch.fulfilled, (state, { payload }) => {
        const deleteBranch = [...state.branches].filter(
          (branch) => branch.id !== payload
        );
        return {
          ...state,
          loading: false,
          branches: deleteBranch,
        };
      })
      .addCase(removeBranch.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default branchSlice.reducer;
